import initialState from './initial.state';
import * as types from '../actions/types.action';

const updateSideBasketStatus = (state, action) => {
  return Object.assign({}, state, {
    sideBasket: action.isLoading
  });
};

export default function loadingReducer(state = initialState.loading, action) {
  switch (action.type) {
    case types.UPDATING_SIDE_BASKET_SUCCESS:
      return updateSideBasketStatus(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/loading.reducer.js